// extracted by mini-css-extract-plugin
export var documentation = "_lj-1";
export var menu = "_lj-0";